export default {
  title: 'Sekret podpisujący webhooka',
  warning:
    'Zapisz ten sekret teraz — nie zostanie pokazany ponownie. Użyj go do weryfikacji nagłówka X-Webhook-Signature.',
  done: 'Gotowe',
};
